import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import HeaderCustom from "../../../../components/HeaderCustom";
import { Backdrop, Box, CircularProgress, Container } from "@mui/material";
import { getCategorias, getFiltrarLocales, getFiltrarLocalesGiftCard, getLocales } from "../../../../api/ApiService";

import { useNavigate } from "react-router-dom";
import LocalesGiftCardHeader from "./components/LocalesGiftCardHeader";
import GiftCardLocalesTableComponent from "./components/GiftCardLocalesTableComponent";
import FitrosLocalesGiftCardComponent from "./components/FitrosLocalesGiftCardComponent";



function EmpresasGiftCardPage() {
    const [nameCedula, setNameCedula] = useState('');
    const [loading, setLoading] = useState(false);
    const [dataLocales, setDataLocales] = useState([]);
    const [loadingCargar, setLoadingCargar] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [localSelected, setLocalSelected] = useState(null);
    const [loadingDescargar, setLoadingDescargar] = useState(false);

    const [estadoSelected, setEstadoSelected] = useState({ label: 'Todos', value: "todos", id: 3 });
    const [estadoSearch, setEstadoSearch] = useState('');

    const [categorias, setCategorias] = useState([]);
    const [categoriaSearch, setCategoriaSearch] = useState('');
    const [categoriaSelected, setCategoriaSelected] = useState(null);

    const [metaPaginacion, setMetaPaginacion] = useState({
        current_page: 1,
        per_page: 10,
        total: 0,
        last_page: 1
    });
    const [perPage, setPerPage] = useState(10);




    const stateToken = useSelector(state => state.reducerGlobal.token);

    let history = useNavigate();








    useEffect(() => {
        const timeOutId = setTimeout(() => {
            if (nameCedula.length > 2) {
                handleApiFiltrarLocalesTituloEstado(nameCedula);
            } else {
                handleApiFiltrarLocales(1);
            }
        }, 1500);
        return () => clearTimeout(timeOutId);
    }, [stateToken, nameCedula, estadoSelected, categoriaSelected, perPage]);



    //============================================================ funcion para filtrar por estado y nombre
    const handleApiFiltrarLocalesTituloEstado = (titulo) => {

        let body = {
            page: 1,
            per_page: perPage,
            nombre: titulo,
        };
        // console.log("handleApiFiltrarLocalesTituloEstado===>>", body);


        setLoadingCargar(true);

        getFiltrarLocalesGiftCard(stateToken?.access_token, body)
            .then(response => {
                // console.log("response==>getFiltrarLocales", response);

                setLoadingCargar(false);
                // setMetaPaginacion(response.meta);

                if (response.data.length > 0) {
                    setDataLocales(response.data);
                    setLoading(true);
                } else {
                    setDataLocales([]);
                    setLoading(true);
                }

                setMetaPaginacion({
                    current_page: response?.current_page,
                    per_page: response?.per_page,
                    total: response?.total,
                    last_page: response?.last_page
                });


            })
            .catch(error => {
                console.log("error==>getFiltrarLocales", error);
                setDataLocales([]);
                setLoading(true);
                setLoadingCargar(false);
            })
    };












    //============================================================ funcion para filtrar por estado y nombre
    const handleApiFiltrarLocales = (page = 1) => {
        let body = {
            page: page,
            per_page: perPage,
            nombre: nameCedula,
        };
        // console.log("handleApiFiltrarLocales====>>", body);
        // console.log("categoriaSelected", categoriaSelected);


        setLoadingCargar(true);

        getFiltrarLocalesGiftCard(stateToken?.access_token, body)
            .then(response => {
                console.log("response==>getFiltrarLocales", response);

                setLoadingCargar(false);

                if (response.data.length > 0) {
                    setDataLocales(response.data);
                    setLoading(true);
                } else {
                    setDataLocales([]);
                    setLoading(true);
                }

                setMetaPaginacion({
                    current_page: response?.current_page,
                    per_page: response?.per_page,
                    total: response?.total,
                    last_page: response?.last_page
                });


            })
            .catch(error => {
                console.log("error==>getFiltrarLocales", error);
                setDataLocales([]);
                setLoading(true);
                setLoadingCargar(false);
            })
    };













    //=============================================funcion para editar
    const handleEditClick = (item) => {
        console.log('Edit', item?.id);
        history(`/app/admin/paseo-plus/add-local/${item?.id}`);
    };


    //=============================================funcion para ver sin editar el local
    const handleVerLocal = (item) => {
        console.log('Edit', item?.id);
        // history(`/app/admin/local-detalle/${item?.id}?mode=view`);
          history(`/app/admin/paseo-plus/add-local/${item?.id}?mode=view`);
    };




    const handleAddLocal = () => {
        history('/app/admin/paseo-plus/add-local');
    };

    const handlePerPageChange = (newPerPage) => {
        setPerPage(newPerPage);
    };


    //=================================================================================================funcion para capturar el name y cedula
    const handleNameCedula = (e) => {
        setNameCedula(e);
    }




    return (
        <HeaderCustom>
            <div className="min-h-screen bg-gray-100 p-6">
                {loading ? (
                    <div>
                        <LocalesGiftCardHeader
                            title="Empresas"
                            subtitle="Administra y supervisa los locales de la plataforma."
                            handleAdd={handleAddLocal}
                        />




                        <div>

                            <FitrosLocalesGiftCardComponent
                                nameCedula={nameCedula}
                                handleNameCedula={handleNameCedula}
                            />

                            <GiftCardLocalesTableComponent
                                data={dataLocales}
                                metaPaginacion={metaPaginacion}
                                onPageChange={handleApiFiltrarLocales}
                                perPage={perPage}
                                onPerPageChange={handlePerPageChange}
                                handleEditarItem={handleEditClick}
                                handleVerLocal={handleVerLocal}
                            />
                        </div>

                    </div>
                ) : (
                    <div className="bg-white rounded-xl shadow-md p-8">
                        <div className="h-6 bg-gray-200 rounded w-1/3 mb-6 animate-pulse" />
                        <div className="space-y-4">
                            <div className="h-10 bg-gray-200 rounded animate-pulse" />
                            <div className="h-10 bg-gray-200 rounded animate-pulse" />
                            <div className="h-24 bg-gray-200 rounded animate-pulse" />
                        </div>
                    </div>
                )}




                <Backdrop open={loadingCargar} sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}>
                    <CircularProgress color="inherit" />
                </Backdrop>
            </div>
        </HeaderCustom>
    );
}

export default EmpresasGiftCardPage;